import { TIERS_RESOURCE, TIERS_TYPES, tiersTypeLabel } from './tiersConstants'

const emptyTiers = ({
  name: null,
  type: null,
  address: null,
  phone: null,
  email: null,
  website: null,
  comment: null,
  favorite: false,
  interlocuteurs: []
})

export default {
  name: 'TiersMixin',
  data () {
    return {
      submitLoading: false,
      id: null,
      // set to true in the upper component that call this mixin all children components witch embed this Mixin
      isParent: false,
      loading: false,
      tiers: null,
      tiersTypes: TIERS_TYPES
    }
  },
  computed: {
    t () {
      return this.tiers
    },
    tiersPk () {
      if (this.t) {
        return this.t.pk
      } else if (this.$route.params.id) {
        return this.$route.params.id
      } else return null
    },
    tiersView () {
      return this.$route.name
    },
    tiersTabLinks () {
      return [
        { link: 'TiersInterlocuteurs', label: 'Interlocuteurs' },
        { link: 'TiersHistory', label: 'Historique' }
      ]
    }
  },
  props: {
    sourceTiers: Object,
    sourceLoading: {
      type: Boolean,
      default: false
    },
    fromQuickview: {
      type: Boolean,
      default: false
    },
    newTiers: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    tiersTypeLabel
  },
  watch: {
    sourceLoading (v) {
      this.loading = v
    },
    '$route.params.id' (to, from) {
      if (to && to !== from) {
        this.initView(to)
      }
    }
  },
  created () {
    this.initView()
  },
  methods: {
    tiersTypeLabel,
    initView () {
      if (this.sourceTiers) {
        this.initTiers({ ...this.sourceTiers })
      } else if (this.$route.params.id) {
        this.id = this.$route.params.id
        this.getTiers(this.id)
      } else {
        this.initTiers(JSON.parse(JSON.stringify(emptyTiers)))
      }
    },
    initTiers (tiers) {
      this.$set(this, 'tiers', tiers)
    },
    /**
     * @param { String } id - id of tiers to get
     */
    async getTiers (id) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(TIERS_RESOURCE, id)
        this.initTiers(data)
        this.loading = false
      } catch (e) {
        this.$router.replace({ name: 'NotFound' })
        this.loading = false
      }
    },
    /**
     * @param { Object } tiers - tiers to create
     */
    async createTiers (tiers) {
      this.submitLoading = true
      try {
        let { data } = await this.$api.post(TIERS_RESOURCE, this.$cleanPayload(tiers))
        this.submitLoading = false
        this.$toasted.global.success('Tiers ajouté')
        this.$router.replace({ name: 'TiersInterlocuteurs', params: { id: data.pk } })
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } tiers - tiers to update
     */
    async updateTiers (tiers) {
      this.submitLoading = true
      try {
        let { data } = await this.$api.put(TIERS_RESOURCE, tiers.pk, this.$cleanPayload(tiers))
        this.submitLoading = false
        this.$toasted.global.success('Tiers modifié')
        this.initTiers(data)
        this.$router.goBack()
      } catch (e) {
        this.submitLoading = false
        if (e.response && JSON.stringify(e.response.data).includes('INTERLOCUTEUR_IN_USE')) {
          this.$toasted.global.danger('Suppression impossible : un interlocuteur retiré est utilisé — voir l\'onglet Historique de la fiche')
        } else {
          this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
        }
      }
    },
    /**
     * @param { Object } tiers - tiers to patch
     * @param { Object } newVal - new values to edit in current tiers
     * @param { Boolean } background - for background update, avoid toast
     */
    async patchTiers (tiers, newVal, background = false) {
      if (!background) this.submitLoading = true
      try {
        let { data } = await this.$api.patch(TIERS_RESOURCE, tiers.pk, this.$cleanPayload(newVal))
        if (!background) {
          this.submitLoading = false
          this.$toasted.global.success('Tiers modifié')
        }
        this.initTiers(data)
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } tiers - tiers to delete
     */
    deleteTiers (tiers) {
      this.$swal({
        title: 'Suppression tiers',
        text: 'Êtes vous sûr de vouloir supprimer ce tiers ? Les éléments qui le référencent conserveront les informations déjà saisies.',
        confirmButtonText: 'Supprimer',
        focusConfirm: false,
        customClass: {
          confirmButton: 'is-danger'
        }
      }).then(async value => {
        if (value && value.dismiss) {
        } else if (value) {
          this.loading = true
          try {
            await this.$api.delete(TIERS_RESOURCE, tiers.pk)
            this.loading = false
            this.$toasted.global.success('Tiers supprimé')
            this.$router.push({ name: 'TiersList' })
          } catch (e) {
            this.loading = false
            if (e.response && JSON.stringify(e.response.data).includes('TIERS_IN_USE')) {
              this.$toasted.global.danger('Suppression impossible : ce tiers est utilisé — voir l\'onglet Historique de sa fiche')
            } else {
              this.$toasted.global.danger('Erreur lors de la suppression !')
            }
          }
        }
      })
    }
  }
}
